
/**
 * 格式化日期为 YYYY-MM-DD
 */
export function formatCalendarDate(date) {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * 格式化日期为 YYYY-MM-DD HH:mm:ss
 */
export function formatDate(date) {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hours = String(d.getHours()).padStart(2, '0')
  const minutes = String(d.getMinutes()).padStart(2, '0')
  const seconds = String(d.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

/**
 * 格式化为前端显示的日期格式 (YYYY-MM-DD HH:mm:ss)
 */
export function formatDateToFrontend(date) {
  return formatDate(date)
}

/**
 * 获取某一天的开始和结束时间
 */
export function getDayStartAndEnd(dateStr) {
  const date = dateStr ? new Date(dateStr) : new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  
  const startTime = new Date(year, month, day, 0, 0, 0)
  const endTime = new Date(year, month, day, 23, 59, 59)
  
  return {
    startTime: formatDate(startTime),
    endTime: formatDate(endTime)
  }
}
